import * as React from "react";

const PaintBucket = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 1.5a.5.5 0 1 0-1 0v.838c-.252.064-.49.195-.687.392L1.337 7.706a1.5 1.5 0 0 0-.026 2.096l3.62 3.8a1.5 1.5 0 0 0 2.147.027l5.068-5.068a1.5 1.5 0 0 0 0-2.122L8.434 2.73c-.13-.128-.277-.23-.434-.301V1.5zM11.293 8H2.457L7 3.457V4.5a.5.5 0 0 0 1 0v-.79l3.439 3.437a.5.5 0 0 1 0 .707L11.293 8zm1.628 2.222a.56.56 0 0 0-.842 0l-1.15 1.315C9.746 12.887 10.705 15 12.5 15s2.753-2.113 1.572-3.463l-1.15-1.315z" />
  </svg>
);

export default PaintBucket;
